module.exports = __webpack_public_path__ + "assets/media/chart-error.b68f4864.svg";